import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[wizardStep]',
})
export class WizardStepDirective {
  constructor(public template: TemplateRef<any>) {}
}
